// @ts-nocheck
import StyleGuideExternalApi from './style-guide-external-api'

export default function initializeStyleGuideExternalApi(
  appConfig,
  styleGuideConfig?: any,
) {
  if (window.seamlyStyleGuide && !Array.isArray(window.seamlyStyleGuide)) {
    throw new Error(
      'Seamly UI has already been initialised. Use the window.seamly object to start new instances instead.',
    )
  }
  const seamlyActions = Array.isArray(window.seamlyStyleGuide)
    ? window.seamlyStyleGuide
    : []
  const seamly = new StyleGuideExternalApi(appConfig, styleGuideConfig)
  window.seamly = seamly
  window.seamlyStyleGuide = { push: seamly.push.bind(seamly) }

  seamly.push(...seamlyActions)
}
